import React, { useMemo, useState, useRef, useEffect } from 'react';
import { useTable, usePagination, useGlobalFilter } from 'react-table';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,Button, Select, MenuItem, CircularProgress, FormControl, Dialog, DialogTitle, DialogContent, DialogActions, TextField, InputLabel, Alert } from '@mui/material';
import { Box } from '@mui/system';
import {
  AppTasks,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppWidgetSummary,
} from '../sections/@dashboard/app';

const fetchData = async (url) => {
  const response = await fetch(url);
  return response.json();
};

export default function BrechasPage() {
  const theme = useTheme();
  const tipo = localStorage.getItem('Tipo');
  const transportista = localStorage.getItem('Transportista');
  const [mandante, setMandante] = useState(localStorage.getItem('Mandante')); 
  const [plantas, setPlantas] = useState([]);
  const [selectedPlanta, setSelectedPlanta] = useState('');
  const [selectedMes, setSelectedMes] = useState('');
  const [selectedAño, setSelectedAño] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [estadoBrecha, setEstadoBrecha] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [consultado, setConsultado] = useState(false);
  const [jsonDesviaciones, setJsonDesviaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(false); 
  const [updateInfo, setUpdateInfo] = useState(true);
  
  // Debug: Observar cambios en estadoBrecha
  useEffect(() => {
    console.log('estadoBrecha cambió a:', estadoBrecha);
  }, [estadoBrecha]); 
  
  useEffect(() => {
    fetchData(`https://asetran.cl/api/enex/listado_planta.php?mandante=${mandante}`)
      .then(data => setPlantas(data))
      .catch(error => console.error(error));

    setUpdateInfo(false)
  }, [updateInfo]);

  const currentYear = new Date().getFullYear();
  const years = [currentYear, currentYear - 1];
  const months = [...Array(12).keys()].map(i => ({
    value: i + 1,
    label: new Date(0, i + 1, 0).toLocaleString('es-ES', { month: 'long' })
  }));
  
  const data = useMemo(() => jsonDesviaciones, [jsonDesviaciones]);

  const columns = useMemo(() => [
    { Header: 'Id', accessor: 'Id', width: '10%' },
    { Header: 'Patente', accessor: 'Patente', width: '12%' },
    { Header: 'Fecha de Cierre', accessor: 'FechaHora', width: '10%'  },
    { Header: 'Desviacion', accessor: 'Desviacion', width: '30%' }, 
    { Header: 'Estado', accessor: 'Estado', width: '10%' },
    { Header: 'Observacion', accessor: 'Observacion', width: '10%' },
    {
        Header: 'Evidencia',
        accessor: 'Evidencia',
        width: '20%',
        Cell: ({ value }) => (
            value ? (
                <a
                    href={`https://asetran.cl/api/enex/uploads/${value}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                >
                    Descargar Evidencia
                </a>
            ) : null
        )
    }, 
    { Header: 'Revision ASETRAN', accessor: 'Aprobado', width: '10%' },
    { Header: 'Acciones', Cell: ({ row }) => <Button variant="contained" color="warning" onClick={() => handleOpenModalEvidencia(row)} sx={{ marginLeft: '15px' }}> Revision </Button>}
  ], []);


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex, pageSize },
  } = useTable(
    { columns, data },
    useGlobalFilter,
    usePagination
  );

  const [modalIsOpenEvidencia, setModalIsOpenEvidencia] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const handleCloseModal = () => {
    setModalIsOpenEvidencia(false);
    setEstadoBrecha(''); // Añadir esta línea
    setObservaciones(''); // Añadir esta línea
  };

  const handleOpenModalEvidencia = (row) => {
    console.log('Abriendo modal para row:', row.original);
    setSelectedRow(row.original.Id); 
    setModalIsOpenEvidencia(true);
  };

  const actualizarDesviacion = async () => {
    console.log('Estado Brecha:', estadoBrecha);
    
    // Si estadoBrecha es "1", significa que se aprueba el cierre de la brecha
    const aprobado = estadoBrecha === "1" ? 1 : 0;

    console.log('Aprobado:', aprobado);

    // Si estadoBrecha es "1", significa que se cierra la brecha
    const cerrado = estadoBrecha === "1" ? 1 : 0;

    console.log('Cerrado:', cerrado);
    
    const url = 'https://asetran.cl/api/enex/actualizar_desviacion_asetran.php';

    // Crear un objeto FormData
    const formData = new FormData();
    formData.append('id', selectedRow);
    formData.append('respuesta', observaciones);
    formData.append('cerrado', cerrado);
    formData.append('aprobado', aprobado);

    // Enviar solicitud POST
    try {
        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const data = await response.json();
        // Manejar la respuesta (por ejemplo, mostrar un mensaje, actualizar el estado, etc.)
    } catch (error) {
        // Manejar error
        console.error("Hubo un error al enviar la solicitud:", error);
    }
  };

  const handleUpdate = async () => {
    setIsLoading(true);
    actualizarDesviacion()
    setTimeout(() => {
      setEstadoBrecha(''); // Añadir esta línea
      setObservaciones(''); // Añadir esta línea
      setModalIsOpenEvidencia(false);
      handleConsultar();
      setIsLoading(false);
    }, "1000");
  };

  const handleMandante= async (id) => {
    setMandante(id)
    setUpdateInfo(true)
  };

  const handleConsultar = async () => {
    let url7
    if(transportista > 1){
      url7 = `https://asetran.cl/api/enex/transportista/listado_brechas.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
    } else {
      url7 = `https://asetran.cl/api/enex/listado_brechas.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
    }
    setConsultado(false);
    setIsLoading(true);

    const response7 = await fetch(url7);
    const data7 = await response7.json();
    
    setJsonDesviaciones(data7); // suponiendo que tienes un estado para este valor 

    setConsultado(true);
    setIsLoading(false);
  };

  return (
    <>
      <Helmet>
        <title> ENEX Check - ASETRAN</title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Listado de Observaciones - Brechas Cerradas
        </Typography>

        {tipo === 'Administrador' && (
          <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
            <InputLabel sx={{ marginTop: '-8px' }}>Mandante</InputLabel>
            <Select
              value={mandante}
              onChange={e => handleMandante(e.target.value)}
            >
                <MenuItem key={13} value={13}>ENEX</MenuItem>
                <MenuItem key={20} value={20}>MEJILLONES</MenuItem>
                <MenuItem key={22} value={22}>LA GREDA</MenuItem>
            </Select>
          </FormControl> 
        )}

        <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
          <InputLabel sx={{ marginTop: '-8px' }}>Planta</InputLabel>
          <Select
            value={selectedPlanta}
            onChange={e => setSelectedPlanta(e.target.value)}
          >
            {plantas.map(item => 
              <MenuItem key={item.id} value={item.id}>{item.planta}</MenuItem>
            )}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
          <InputLabel sx={{ marginTop: '-8px' }}>Mes</InputLabel>
          <Select
            value={selectedMes}
            onChange={e => setSelectedMes(e.target.value)}
          >
            {months.map((month, index) => 
              <MenuItem key={index} value={month.value}>{month.label}</MenuItem>
            )}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
          <InputLabel sx={{ marginTop: '-8px' }}>Año</InputLabel>
          <Select
            value={selectedAño}
            onChange={e => setSelectedAño(e.target.value)}
          >
            {years.map(year => 
              <MenuItem key={year} value={year}>{year}</MenuItem>
            )}
          </Select>
        </FormControl>

        <Button variant="contained" color="primary" onClick={handleConsultar} sx={{ marginLeft: '15px' }}>
          {isLoading ? 'Cargando...' : 'Consultar'}
        </Button>
        
        {consultado && jsonDesviaciones.length > 0 &&(
          <Grid container spacing={3} style={{marginTop: '1%'}}>
            
            <Grid item xs={12} md={12} lg={12}>
              <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
                <TableContainer component={Paper} sx={{ width: '100%', overflow: 'auto' }}>
                  <Table {...getTableProps()} sx={{ minWidth: 750 }}>
                    <TableHead>
                      {headerGroups.map(headerGroup => (
                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map(column => (
                            <TableCell {...column.getHeaderProps()}>{column.render('Header')}</TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableHead>
                    <TableBody {...getTableBodyProps()}>
                      {page.map(row => {
                        prepareRow(row);
                        return (
                          <TableRow {...row.getRowProps()}>
                            {row.cells.map(cell => (
                              <TableCell {...cell.getCellProps()} style={{ width: cell.column.width }}>{cell.render('Cell')}</TableCell>
                            ))}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>

                <FormControl>
                  <Typography component="div">
                    Página{' '}
                    <strong>
                      {pageIndex + 1} de {pageOptions.length}
                    </strong>{' '}
                  </Typography>


                </FormControl>

                <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                  {'<<'}
                </Button>
                <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
                  {'<'}
                </Button>
                <Button onClick={() => nextPage()} disabled={!canNextPage}>
                  {'>'}
                </Button>
                <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                  {'>>'}
                </Button>
              </Box>

              <Dialog
                open={modalIsOpenEvidencia}
                onClose={handleCloseModal}
              >
                <DialogTitle>Revisión ASETRAN</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel>Aprobar/Rechazar</InputLabel>
                    <Select
                      value={estadoBrecha}
                      onChange={e => {
                        console.log('Valor seleccionado:', e.target.value);
                        setEstadoBrecha(e.target.value);
                      }}
                    >
                      <MenuItem value="1">Aprobar Cierre Brecha</MenuItem>
                      <MenuItem value="0">Rechazar Cierre Brecha</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    margin="dense"
                    label="Observaciones"
                    fullWidth
                    multiline
                    rows={4}
                    value={observaciones}
                    onChange={e => setObservaciones(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseModal}>Cerrar</Button>
                  <Button onClick={handleUpdate}>{isLoading ? 'Cargando...' : 'Actualizar'}</Button>
                </DialogActions>
              </Dialog>

            </Grid>

          </Grid>
        )}
      </Container>
    </>
  );
}
